
import styled from "styled-components"

export const TagContainer = styled.div`
display:block;
flex-wrap:wrap;
justify-content:space-around;
line-height:1.5;
`